import React from 'react';
import {Col, Row, UiCheckbox, UiInput, UiText} from '.';
import {UiImage} from './UiImage';

interface Props {
  text: string;
  checked?: boolean;
  style?: React.CSSProperties;
  onClick?: () => any;
  direction?: 'row' | 'column';
}

const CustomRadio = ({text, checked, style, onClick, direction = 'column'}: Props) => {
  if (direction === 'row') {
    return (
      <Row style={style} onClick={onClick}>
        {checked ? (
          <UiImage type="icon" name="check" width={6} height={6} />
        ) : (
          <div style={{width: 24, height: 24, borderRadius: 50, borderColor: '#457672', borderWidth: 1}} />
        )}
        <UiText textAlign="center" ml={5}>
          {text}
        </UiText>
      </Row>
    );
  }
  return (
    <Col style={style} onClick={onClick}>
      {checked ? (
        <UiImage type="icon" name="check" width={6} height={6} />
      ) : (
        <div style={{width: 24, height: 24, borderRadius: 50, borderColor: '#457672', borderWidth: 1}} />
      )}
      <UiText textAlign="center">{text}</UiText>
    </Col>
  );
};

export default CustomRadio;
